import { useMemo, useState } from "react";
import Card, { Bar } from "./Card.jsx";
import Ball from "../Ball.jsx";
import { getRelatedNumbers, topByCount } from "../../lib/lotto.js";

export default function Related({ rows }) {
  const [num, setNum] = useState(7);
  const related = useMemo(() => {
    const r = getRelatedNumbers(rows, num).filter((x) => x.num !== num);
    return topByCount(r, 10);
  }, [rows, num]);
  const max = related[0]?.count ?? 1;

  return (
    <Card title="연관번호" subtitle={`#${num} 과 함께 자주 나온 번호`} span={1}>
      <div className="controls" style={{ marginBottom: 8 }}>
        <label>
          기준 번호:&nbsp;
          <input
            type="number"
            min={1}
            max={45}
            value={num}
            onChange={(e) =>
              setNum(Math.max(1, Math.min(45, Number(e.target.value) || 1)))
            }
          />
        </label>
        <Ball n={num} />
      </div>
      {related.map((r) => (
        <Bar
          key={r.num}
          value={r.count}
          max={max}
          label={<Ball n={r.num} />}
        />
      ))}
    </Card>
  );
}
